export default [
  {
    path: '/transaction-types',
    name: 'transaction-types',
    component: () => import('@/views/billing/transaction-types/pages/TransactionTypeList.vue'),
    meta: {
      resource: 'transaction-types',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Transaction Types',
      breadcrumb: [
        {
          text: 'Transaction Types',
          active: true,
        },
      ],
    },
  },
  {
    path: '/transaction-types/new',
    name: 'transaction-types-new',
    component: () => import('@/views/billing/transaction-types/pages/AddTransactionType.vue'),
    meta: {
      resource: 'transaction-types',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'New Transaction Type',
      breadcrumb: [
        {
          text: 'Transaction Types',
          to: '/transaction-types',
        },
      ],
    },
  },
  {
    path: '/transaction-types/:id',
    name: 'transaction-types-edit',
    component: () => import('@/views/billing/transaction-types/pages/EditTransactionType.vue'),
    meta: {
      resource: 'transaction-types',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Edit Transaction Type',
      breadcrumb: [
        {
          text: 'Transaction Types',
          to: '/transaction-types',
        },
      ],
    },
  },
  {
    path: '/pricing-config',
    name: 'pricing-config',
    component: () => import('@/views/billing/versions/pages/PricingConfig.vue'),
    meta: {
      resource: 'versions',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Pricing Configuration',
      breadcrumb: [
        {
          text: 'Pricing Configuration',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pricing-templates',
    name: 'pricing-templates',
    component: () => import('@/views/billing/templates/pages/ListTemplate.vue'),
    meta: {
      resource: 'templates',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Pricing Templates',
      breadcrumb: [
        {
          text: 'Pricing Templates',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pricing-templates/edit/:id',
    name: 'templates-edit',
    component: () => import('@/views/billing/templates/pages/EditTemplate.vue'),
    meta: {
      resource: 'templates',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Pricing Templates',
      breadcrumb: [
        {
          text: 'Pricing Templates',
          to: '/pricing-templates',
        },
      ],
    },
  },
  {
    path: '/templates/new',
    name: 'templates-new',
    component: () => import('@/views/billing/templates/pages/AddTemplate.vue'),
    meta: {
      resource: 'templates',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Pricing Templates',
      breadcrumb: [
        {
          text: 'Pricing Templates',
          to: '/pricing-templates',
        },
      ],
    },
  },
  {
    path: '/versions/history',
    name: 'versions-history',
    component: () => import('@/views/billing/versions/pages/VersionsHistory.vue'),
    meta: {
      resource: 'versions',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Versions History',
      breadcrumb: [
        {
          text: 'Versions History',
          active: true,
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/versions/prepare-pricing',
    name: 'versions-prepare-pricing',
    component: () => import('@/views/billing/versions/pages/PreparePricing.vue'),
    meta: {
      resource: 'versions',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Pricing Config',
      breadcrumb: [
        {
          text: 'Pricing Configuration',
          active: true,
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/versions/new',
    name: 'versions-new',
    component: () => import('@/views/billing/versions/pages/AddVersion.vue'),
    meta: {
      resource: 'versions',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Versions',
      breadcrumb: [
        {
          text: 'Pricing Configuration',
          to: '/versions/prepare-pricing',
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/versions/edit/:id',
    name: 'versions-edit',
    component: () => import('@/views/billing/versions/pages/EditVersion.vue'),
    meta: {
      resource: 'versions',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Versions',
      breadcrumb: [
        {
          text: 'Pricing Configuration',
          to: '/pricing-config',
        },
      ],
    },
    allowedCountries: ['LY'],
  },
  {
    path: '/vouchers/vendors',
    name: 'vendors',
    component: () => import('@/views/billing/vouchers/vendors/pages/VendorsList.vue'),
    meta: {
      resource: 'vendors',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Vendors',
      breadcrumb: [
        {
          text: 'Vendors',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vouchers/vendors/new',
    name: 'vendors-new',
    component: () => import('@/views/billing/vouchers/vendors/pages/AddVendor.vue'),
    meta: {
      resource: 'vendors',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Vendors',
      breadcrumb: [
        {
          text: 'Vendors',
          to: '/vouchers/vendors',
        },
      ],
    },
  },
  {
    path: '/vouchers/cards',
    name: 'cards',
    component: () => import('@/views/billing/vouchers/cards/pages/VoucherCardsList.vue'),
    meta: {
      resource: 'voucher-cards',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Voucher Cards',
      breadcrumb: [
        {
          text: 'Voucher Cards',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vouchers/cards/batch',
    name: 'batch',
    component: () => import('@/views/billing/vouchers/batch/pages/BatchList.vue'),
    meta: {
      resource: 'voucher-cards',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Batch Jobs',
      breadcrumb: [
        {
          text: 'Batch Jobs',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bulks/create',
    name: 'create-transaction-bulks',
    component: () => import('./transaction-bulks/pages/CreateTransactionBulk.vue'),
    meta: {
      resource: 'transaction-bulks',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Transaction Bulks',
      breadcrumb: [
        {
          text: 'Transaction Bulks',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bulks/list',
    name: 'transaction-bulks-list',
    component: () => import('./transaction-bulks/pages/TransactionBulksList.vue'),
    meta: {
      resource: 'transaction-bulks',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Transaction Bulks',
      breadcrumb: [
        {
          text: 'Transaction Bulks',
          active: true,
        },
      ],
    },
  },
  {
    path: '/payouts/new',
    name: 'new',
    component: () => import('@/views/billing/payouts/pages/CreateNewPayout.vue'),
    meta: {
      resource: 'payout-actions',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Payouts',
      breadcrumb: [
        {
          text: 'new payout',
          active: true,
        },
      ],
    },
  },
  {
    path: '/payouts/pending',
    name: 'pending',
    component: () => import('@/views/billing/payouts/pages/PayoutsPending.vue'),
    meta: {
      resource: 'payout-actions',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Payouts List',
      breadcrumb: [
        {
          text: 'Pending',
          active: true,
        },
      ],
    },
  },
  {
    path: '/payouts/approved',
    name: 'approved',
    component: () => import('@/views/billing/payouts/pages/PayoutsApproved.vue'),
    meta: {
      resource: 'payout-actions-pay',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Payouts List',
      breadcrumb: [
        {
          text: 'Approved',
          active: true,
        },
      ],
    },
  },
  {
    path: '/payouts/rejected',
    name: 'rejected',
    component: () => import('@/views/billing/payouts/pages/PayoutsRejected.vue'),
    meta: {
      resource: 'payout-actions',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Payouts List',
      breadcrumb: [
        {
          text: 'Rejected',
          active: true,
        },
      ],
    },
  },
  {
    path: '/payouts/paid',
    name: 'paid',
    component: () => import('@/views/billing/payouts/pages/PayoutsPaid.vue'),
    meta: {
      resource: 'payout-actions',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Payouts List',
      breadcrumb: [
        {
          text: 'Paid',
          active: true,
        },
      ],
    },
  },
  {
    path: '/zones-management/sub-zones',
    name: 'zones-management-sub-zones',
    component: () => import('@/views/billing/zones-management/SubZonesList.vue'),
    meta: {
      resource: 'pricing-overrides',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Zones Management',
      breadcrumb: [
        {
          text: 'Zones Management',
          active: true,
        },
      ],
    },
  },
]
